/** A service with timers or listeners that can be shut down. */
export interface IStoppableService {
    stop(): void;
}

/**
 * Keeps the single running instance of a service. In development Vite (HMR) runs a changed service module again and
 * creates a new instance, while the old one would keep its timers and listeners — every edit added another `/whoAmI`
 * poll. In production the module runs once, so nothing is stopped. The instances live on `globalThis`, the one thing
 * that survives such a run.
 */
class ServiceRegistryClass {
    private readonly Registry = globalThis as typeof globalThis & { __dwcServices?: Map<string, IStoppableService> };

    /** Registers `service` under `key` and stops the one before. */
    public register<T extends IStoppableService>(key: string, service: T): T {
        const Services = (this.Registry.__dwcServices ??= new Map<string, IStoppableService>());
        Services.get(key)?.stop();
        Services.set(key, service);

        return service;
    }
}

export const ServiceRegistry = new ServiceRegistryClass();
